


































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import MachineRentTab from '@/app/components/MachineRent/MachineRentTab.vue'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    MachineRentTab
  }
})
export default class MachineRentSearch extends Vue {
  @Prop() private count!: number
  private machineType: number|null = null
  private stasusSelected: any = [
    { text: 'すべて', value: null },
    { text: '除草', value: 1 },
    { text: '収穫', value: 2 },
    { text: '剪定', value: 3 }
  ]

  @Watch('machineType')
  changeMachineType (type: number|null) {
    this.$emit('change-machine-type', type)
  }
}
